import { KnmAgreementStatusEnum } from 'KnmErknmPackage/ErknmViolationsModule/enums/KnmAgreementStatusEnum';

export const mapAgreementStatusToColor: Record<KnmAgreementStatusEnum, 'green' | 'red' | 'yellow'> = {
  [KnmAgreementStatusEnum.AGREEMENT_APPROVED]: 'yellow',
  [KnmAgreementStatusEnum.AGREEMENT_TERMINATED]: 'red',
  [KnmAgreementStatusEnum.AGREEMENT_COMPLETED]: 'green',
  [KnmAgreementStatusEnum.AGREEMENT_NOT_COMPLETED]: 'red',
};
